import { ErrorMessage } from "formik"

import { MuiTelInput } from "mui-tel-input"

import FormLabel from "@mui/material/FormLabel"
import TextField from "@mui/material/TextField"
import FormHelperText from "@mui/material/FormHelperText"
import { LoadingButton } from "@mui/lab"

import { ErrorBox } from "@components/error-box"
import { PasswordInput } from "@components/password-input"

interface SignupBiodataProps {
  formik: any
  navigateError: string
  isLoading?: boolean
  handleNext: () => void
}

export const SignupBiodata = ({
  formik,
  navigateError,
  handleNext,
  isLoading,
}: SignupBiodataProps) => {
  return (
    <>
      <FormLabel>
        Full name
        <TextField
          color="primary"
          name="name"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.name}
        />
        <ErrorMessage component={ErrorBox} name="name" />
      </FormLabel>

      <FormLabel>
        Email
        <TextField
          type="email"
          color="primary"
          name="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
        />
        <ErrorMessage component={ErrorBox} name="email" />
      </FormLabel>

      <FormLabel>
        <PasswordInput
          formlabel="Password"
          hint="Minimum of 6 characters"
          name="password"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
        />
        <ErrorMessage component={ErrorBox} name="password" />
      </FormLabel>

      <FormLabel>
        Whatsapp Phone Number
        <FormHelperText>
          This is important so you can get FREE reminders
        </FormHelperText>
        <MuiTelInput
          color="primary"
          name="phone"
          defaultCountry="NG"
          forceCallingCode
          onChange={(val) => formik.setFieldValue("phone", val)}
          onBlur={formik.handleBlur}
          value={formik.values.phone}
          inputProps={{ autoComplete: "off", form: { autoComplete: "off" } }}
          placeholder="80X XXX XXXX"
        />
        <ErrorMessage component={ErrorBox} name="phone" />
      </FormLabel>
      <LoadingButton
        onClick={handleNext}
        color="primary"
        variant="contained"
        loading={isLoading}
      >
        Continue
      </LoadingButton>
      {navigateError?.length ? <ErrorBox>{navigateError}</ErrorBox> : null}
    </>
  )
}
